// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import workshopContentsSelector from '../../redux/selectors/workshopContentsSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { useCurrentModule, useVodId } from '../../components/CourseContent/hooks';
import { Chapter, Note, Progress } from '../../types/Model';

export function useCreateNote(id: number): (vodId: number, time: number, message: string) => void {
  const dispatch = useDispatch();

  return useCallback((vodId: number, time: number, message: string) => {
    dispatch(actionCreatorsList.createWorkshopNoteActions.request({ id, vodId, time, message }))
  }, [id])
}

export function useUpdateNote(id: number): (noteId: string, message: string) => void {
  const dispatch = useDispatch();

  return useCallback((noteId: string, message: string) => {
    dispatch(actionCreatorsList.updateWorkshopNoteActions.request({ id, noteId, message }));
  }, [id])
}

export function useDeleteNote(id: number): (noteId: string) => void {
  const dispatch = useDispatch();

  return useCallback((noteId: string) => {
    dispatch(actionCreatorsList.deleteWorkshopNoteActions.request({ id, noteId }));
  }, [id])
}

export function useFetchNotes(id: number): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getWorkshopNotesDataActions.request({ id }))
  }, [id])
}

export function useFetchWorkshopInformation(id: number): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getWorkshopDataActions.request({ id }));
  }, [id])
}

export function useFetchWorkshopContents(id: number, preventLoading?: boolean): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getWorkshopContentsDataActions.request({ id, preventLoading }));
  }, [id])
}

export function useUpdateProgress(id: number): (progress: Progress) => void {
  const dispatch = useDispatch();
  const refetchContents = useFetchWorkshopContents(id, true);

  return useCallback((progress: Progress) => {
    dispatch(actionCreatorsList.updateWorkshopProgressActions.request({
      id,
      progress,
      onSuccess: () => refetchContents()
    }))
  }, [id])
}

export function useIsNoteFetching(): boolean {
  return useSelector(workshopContentsSelector.makeIsFetchingWorkshopNotesData());
}

export function useNoteError(): Error | undefined {
  return useSelector(workshopContentsSelector.makeNoteErrorWorkshopNotesData());
}

export function useNotes(id: number, chapters: Chapter[]): Note[] {
  const currentModule = useCurrentModule(chapters)
  const vodId = useVodId(currentModule);
  const notes = useSelector(workshopContentsSelector.makeWorkshopNotesDataByIdSelector(id, vodId));
  return notes;
}

export function useProgress(id: number): Progress[] {
  return useSelector(workshopContentsSelector.makeWorkshopProgressDataByIdSelector(id));
}

export function useHasCourse(id: number): boolean {
  return useSelector(workshopContentsSelector.makeWorkshopHasCourseByIdSelector(id));
}
